import { ReactComponent as beansLegumes } from './beansLegumes.svg';
import { ReactComponent as dipsCondiments } from './dipsCondiments.svg';
import { ReactComponent as grainsBread } from './grainsBread.svg';
import { ReactComponent as salads } from './salads.svg';
import { ReactComponent as smallBites } from './smallBites.svg';
import { ReactComponent as soupsStews } from './soupsStews.svg';
import { ReactComponent as vegetables } from './vegetables.svg';

export const sideCategoryIcons = {
  beansLegumes,
  dipsCondiments,
  grainsBread,
  salads,
  smallBites,
  soupsStews,
  vegetables,
};
